import { languageOptions } from './constants'

type LanguageChangeListener = (
  currentLanguage: string,
  prevLanguage: string
) => void

class I18n {
  private currentLanguage = languageOptions[0]?.key
  private languageChangeListeners: LanguageChangeListener[] = []

  public getCurrentLanguage() {
    return this.currentLanguage || 'en_US'
  }

  public getCurrentLanguageKebabCase() {
    return this.getCurrentLanguage().replace('_', '-')
  }

  public setCurrentLanguage(language: string): void {
    const prevLanguage = this.currentLanguage || 'en_US'
    this.currentLanguage = language || languageOptions[0]?.key
    this.languageChangeListeners.forEach((cb) => {
      cb(language, prevLanguage)
    })
  }

  public onLanguageChange(cb: LanguageChangeListener): () => void {
    this.languageChangeListeners.push(cb)
    return () => {
      this.languageChangeListeners = this.languageChangeListeners.filter(
        (listener) => listener !== cb
      )
    }
  }
}

export const i18nInstance = new I18n()
